import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";

// Dev routes (?reference, ?harness=…) exist only in dev builds: the dynamic
// import is dropped from production bundles because import.meta.env.DEV is a
// compile-time false there.
const DevRoot = import.meta.env.DEV ? lazy(() => import("./dev/harness").then((m) => ({ default: m.DevRoot }))) : null;
const devRoute = import.meta.env.DEV && /[?&](reference|harness)(=|&|$)/.test(location.search);

const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    {devRoute && DevRoot ? (
      <Suspense fallback={null}>
        <DevRoot />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
